export const messages = {
  ru: {
    invoice_flow__kuna__title_text: 'Пополнение {currency} на адрес KUNA кошелька',
  },
  uk: {
    invoice_flow__kuna__title_text: 'Поповнення {currency} за адресою KUNA гаманця',
  },
  en: {
    invoice_flow__kuna__title_text: 'Top-up {currency} at KUNA wallet address',
  },
};
